import { useSelector } from 'react-redux';

/**
 * Every control writes to the URL, not to component state, so a filtered view is
 * a link someone can send. The parent reads the same search params back.
 */
export default function Filters({ params, onChange, onReset }) {
  const { towns, categories, tags } = useSelector((state) => state.config);

  const set = (key, value) => onChange({ ...params, [key]: value || undefined });

  const tagsByKind = tags.reduce((acc, tag) => {
    (acc[tag.kind] = acc[tag.kind] || []).push(tag);
    return acc;
  }, {});

  const activeTags = (params.tag || '').split(',').filter(Boolean);

  const toggleTag = (slug) => {
    const next = activeTags.includes(slug)
      ? activeTags.filter((s) => s !== slug)
      : [...activeTags, slug];

    set('tag', next.join(','));
  };

  return (
    <aside className="filters">
      <div className="filter-block">
        <label htmlFor="filter-town">Town</label>
        <select
          id="filter-town"
          value={params.town_within || ''}
          onChange={(e) => set('town_within', e.target.value)}
        >
          <option value="">Anywhere on LBI</option>
          {towns.map((town) => (
            <optgroup key={town.id} label={town.name}>
              <option value={town.slug}>All of {town.name}</option>
              {town.communities?.map((community) => (
                <option key={community.id} value={community.slug}>
                  {community.name}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>

      <div className="filter-block">
        <label htmlFor="filter-category">Category</label>
        <select
          id="filter-category"
          value={params.category_slug || ''}
          onChange={(e) => set('category_slug', e.target.value)}
        >
          <option value="">Everything</option>
          {categories.map((parent) => (
            <optgroup key={parent.id} label={parent.name}>
              {parent.children?.map((child) => (
                <option key={child.id} value={child.slug}>
                  {child.name}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>

      <div className="filter-block">
        <label htmlFor="filter-season">Season</label>
        <select
          id="filter-season"
          value={params.season || ''}
          onChange={(e) => set('season', e.target.value)}
        >
          <option value="">Any</option>
          <option value="year_round">Open year round</option>
          <option value="seasonal">Seasonal</option>
        </select>
      </div>

      {Object.entries(tagsByKind).map(([kind, kindTags]) => (
        <div className="filter-block" key={kind}>
          <span className="filter-legend">{kind}</span>
          <div className="chip-row">
            {kindTags.map((tag) => (
              <button
                type="button"
                key={tag.id}
                className={activeTags.includes(tag.slug) ? 'chip chip-on' : 'chip'}
                onClick={() => toggleTag(tag.slug)}
              >
                {tag.name}
              </button>
            ))}
          </div>
        </div>
      ))}

      <button type="button" className="btn btn-ghost" onClick={onReset}>
        Clear filters
      </button>
    </aside>
  );
}
